module.exports = __webpack_public_path__ + "static/ls-1ed87a2f0cb3ed4e00e388c7dd3bd73f.png";